import { render } from "./403Forbidden.vue?vue&type=template&id=0a4eba20&scoped=true"
import script from "./403Forbidden.vue?vue&type=script&lang=js"
export * from "./403Forbidden.vue?vue&type=script&lang=js"

import "./403Forbidden.vue?vue&type=style&index=0&id=0a4eba20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4eba20"]])

export default __exports__